import styled from "styled-components";

interface IContainerCartActive {
	active: boolean;
	$isShowSupplier?: boolean;
}

export const ContainerCardShoppingRow = styled.div<IContainerCartActive>`
	position: relative;
	max-width: 100%;
	min-height: 80px;
	width: 100%;
	cursor: pointer;
	overflow: visible;
	${(props) =>
		props.active
			? {
					display: "flex",
					alignItems: "center",
					width: "100%",
				}
			: {
					display: "none",
				}};
`;
export const TextGrid = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: auto;
`;

export const BoxBadge = styled.div`
	position: absolute;
	right: 16px;
	bottom: -10px;
	z-index: 10;
	background-color: #27347b;
	color: #fff;
	border-radius: 50%;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: bold;
`;
